(() => {
  const VERSION = '2.2.0';
  if (window.PBStandaloneCapacitiesV2?.version === VERSION) return;

  const V = window.PBVariantV2;
  if (!V) {
    window.PBStandaloneCapacitiesV2 = { version: VERSION, active: false };
    return;
  }

  const q = (root, selector) => root?.querySelector(selector) || null;
  const qa = (root, selector) => root ? [...root.querySelectorAll(selector)] : [];

  const parse = (root, selector, fallback) => {
    try { return JSON.parse(q(root, selector)?.textContent || JSON.stringify(fallback)); }
    catch { return fallback; }
  };

  const money = cents => new Intl.NumberFormat(undefined, {
    style: 'currency', currency: window.Shopify?.currency?.active || 'USD'
  }).format(Number(cents || 0) / 100);

  const priceCents = variant => {
    const raw = variant?.price ?? 0;
    const value = Number(raw || 0);
    if (!Number.isFinite(value)) return 0;
    return String(raw).includes('.') ? Math.round(value * 100) : Math.round(value);
  };

  const capacity = variant => {
    const values = [
      ...(variant?.options || []),
      variant?.option1 || '', variant?.option2 || '', variant?.option3 || ''
    ];
    for (const value of values) {
      const match = String(value || '').trim().match(/^(\d+)\s*(?:GB|G)$/i);
      if (match) return `${Number(match[1])}GB`;
    }
    return '';
  };

  const available = variant => variant?.available !== false;

  const hideCarrierGrid = carrierGrid => {
    carrierGrid.dataset.pbCapacityCarrier = 'true';
    carrierGrid.hidden = true;
    carrierGrid.setAttribute('aria-hidden', 'true');
    carrierGrid.style.setProperty('display', 'none', 'important');
  };

  const initRoot = root => {
    const variants = parse(root, '[data-pb-variants-json]', []);
    const carrierGrid = q(root, '[data-pb-usb-capacities]');
    const carriers = qa(carrierGrid, '[data-usb-capacity]');
    if (!variants.length || !carrierGrid || !carriers.length) return null;

    const stateVariants = state => variants.filter(variant =>
      V.stateForVariant(variant, 'usb') === state && capacity(variant)
    );
    const noneVariants = stateVariants('none');
    const capacities = [...new Set(noneVariants.map(capacity))]
      .sort((a, b) => Number(a.replace(/\D/g, '')) - Number(b.replace(/\D/g, '')));

    if (!capacities.length) return null;

    hideCarrierGrid(carrierGrid);

    let dynamicGrid = q(root, '[data-pb-standalone-capacities-v2]');
    if (!dynamicGrid) {
      dynamicGrid = document.createElement('div');
      dynamicGrid.className = 'pb-usb-addon__pill-grid';
      dynamicGrid.dataset.pbStandaloneCapacitiesV2 = '';
      carrierGrid.after(dynamicGrid);
    }

    const activeCarrier = () => q(carrierGrid, '[data-usb-capacity].is-active');
    const current = () => activeCarrier()?.dataset.usbCapacity || '';
    const variantFor = (cap, state = 'none') => stateVariants(state).find(variant => capacity(variant) === cap) || null;

    const activate = cap => {
      if (!cap) return;
      const carrier = activeCarrier() || carriers[0];
      if (carrier.dataset.usbCapacity === cap && carrier.classList.contains('is-active')) return;
      carrier.dataset.usbCapacity = cap;
      const span = q(carrier, 'span');
      if (span) span.textContent = cap;
      else carrier.textContent = cap;
      carrier.click();
    };

    const render = ({ force = false } = {}) => {
      hideCarrierGrid(carrierGrid);
      const currentValue = current();
      const sellableCaps = capacities.filter(cap => available(variantFor(cap)));
      const selected = sellableCaps.includes(currentValue)
        ? currentValue
        : sellableCaps[0] || capacities[0];

      if (force || currentValue !== selected) activate(selected);
      dynamicGrid.innerHTML = '';

      capacities.forEach(cap => {
        const variant = variantFor(cap);
        const availableNow = Boolean(variant && available(variant));
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'pb-usb-addon__pill';
        button.dataset.pbStandaloneCapacityV2 = cap;
        button.disabled = !availableNow;
        button.setAttribute('aria-disabled', availableNow ? 'false' : 'true');
        if (cap === (current() || selected)) button.classList.add('is-active');

        const label = document.createElement('span');
        label.textContent = cap;
        const price = document.createElement('strong');
        price.className = 'pb-usb-addon__price-label';
        price.textContent = availableNow ? money(priceCents(variant)) : 'Unavailable';
        button.append(label, price);

        if (availableNow) {
          button.addEventListener('click', event => {
            event.preventDefault();
            activate(cap);
            qa(dynamicGrid, '[data-pb-standalone-capacity-v2]').forEach(el =>
              el.classList.toggle('is-active', el === button)
            );
            queueMicrotask(() => render());
          });
        }
        dynamicGrid.appendChild(button);
      });
    };

    render({ force: true });
    return { root, render, capacities };
  };

  const roots = qa(document, '[id^="PBStandaloneUSBCustomizer-"]').map(initRoot).filter(Boolean);

  window.PBStandaloneCapacitiesV2 = {
    version: VERSION,
    active: true,
    roots,
    refresh: () => roots.forEach(ctx => ctx.render())
  };
})();
